import type { OwnTransfer } from './OwnTransfer';

export const base: OwnTransfer = {
    enabled: true,
    _description: 'Enables Own Transfer feature',
};
